import clsx from 'clsx';
import { FC } from 'react';
import { IRadioComponent } from '../../../types';
import styles from './styles.module.css';

const Radio: FC<IRadioComponent> = props => {
  const { label, disabled = false, errorMessage, ...inputProps } = props;

  const disabledClass = disabled ? styles.disabled : '';

  return (
    <>
      <label className={clsx(styles.labelWrapper, disabledClass)}>
        <input type="radio" disabled={disabled} {...inputProps} />
        <span className={styles.checkmark} />
        <span className={styles.label}>{label}</span>
      </label>
      {Boolean(errorMessage) && <p className={clsx('help', 'is-danger')}>{errorMessage}</p>}
    </>
  );
};

export default Radio;
